
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { TokenPrice } from "../types/prices";

// Mock store
const PRICE_CACHE: Record<string, TokenPrice> = {
    'SOL': { symbol: 'SOL', price: 145.20, change24h: 2.5, lastUpdated: Date.now() },
    'SUI': { symbol: 'SUI', price: 1.65, change24h: -1.2, lastUpdated: Date.now() },
    'USDC': { symbol: 'USDC', price: 1.00, change24h: 0.01, lastUpdated: Date.now() },
};

export const fetchTokenPrice = async (symbol: string): Promise<TokenPrice> => {
    // Simulate API delay
    await new Promise(r => setTimeout(r, 100));

    const cache = PRICE_CACHE[symbol.toUpperCase()];
    if (cache) {
        // Add some jitter to make it feel "live"
        const jitter = cache.price * (Math.random() * 0.002 - 0.001);
        return {
            ...cache,
            price: cache.price + jitter,
            lastUpdated: Date.now()
        };
    }

    // Default random price for unknown tokens
    return {
        symbol: symbol,
        price: Math.random() * 10,
        change24h: (Math.random() * 20) - 10,
        lastUpdated: Date.now()
    };
};
